var _rect, _rect2, _rect3, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenPlacementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 140,
    viewBox: "0 0 183 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 32,
    width: 156,
    height: 76,
    fill: "#FAFAFA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 32,
    width: 156,
    height: 16,
    fill: "#DAD8DA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 56,
    width: 140,
    height: 44,
    fill: "#EFEEEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 63H21V56H28V58H23V63Z",
    fill: "#8454FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M159 63H161V56H154V58H159V63Z",
    fill: "#8454FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154 98V100H161V93H159V98H154Z",
    fill: "#8454FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 98V100H21V93H23V98H28Z",
    fill: "#8454FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenPlacementIcon);
export default __webpack_public_path__ + "static/media/fullscreen-placement-icon.2311aa38c19756d678314fae467dab48.svg";
export { ForwardRef as ReactComponent };